export const getEmailAttchListRequest = (appId: string) => ({
  method: 'GET',
  url: `/modules/email/attachments/${appId}`
})

export const addEmailAttachmentRequest = (
  appId: number,
  attachmentDesc: string,
  createdByName: string,
  updatedByName: string,
  attachmentFile: File
) => {
  const formData = new FormData()
  formData.append('attachment_file', attachmentFile)
  formData.append('app_id', appId.toString())
  formData.append('attachment_desc', attachmentDesc)
  formData.append('created_by_name', createdByName)
  formData.append('updated_by_name', updatedByName)

  return { method: 'POST', url: `/modules/email/attachments`, data: formData }
}

export const editEmailAttachmentRequest = (
  attachmentDesc: string,
  attachmentUUID: string,
  updatedByName: string,
  attachmentFile?: File
) => {
  const formData = new FormData()

  if (attachmentFile) formData.append('attachment_file', attachmentFile)

  formData.append('attachment_desc', attachmentDesc)
  formData.append('updated_by_name', updatedByName)

  return { method: 'PUT', url: `/modules/email/attachments/edit/${attachmentUUID}`, data: formData }
}

export const deleteEmailAttachmentRequest = (attachmentUUID: string) => ({
  method: 'DELETE',
  url: `/modules/email/attachments/delete/${attachmentUUID}`
})

export const downloadEmailAttachmentRequest = (attachmentUUID: string) => ({
  method: 'GET',
  url: `/modules/email/attachments/download/${attachmentUUID}`
})
